import downloadIcon from "../../assets/images/download-icon.png";
import React, { useState, useEffect } from "react";
import axios from "axios";

const Catalog = () => {
  const [download, setDownload] = useState([]);

  useEffect(() => {
    getDownloads();
  }, []);

  const getDownloads = async (e) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}download`
      );
      setDownload(response.data.downloads);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <section className="pt-2  pb-2 md:pt-2 md:mt-10" id="catalog">
      <div
        className="container mx-auto px-6"
        data-aos="fade-down"
        data-aos-duration="800"
      >
        <div className="font-poppins  flex justify-center md:justify-normal  flex-col md:flex-row items-center  p-4 md:p-8 contact-box">
          <div className=" pl-4 pt-5 md:mr-8 mb-4">
            <h3 className="text-slate-800 text-3xl md:text-3xl font-semibold text-center">
              Download <br /> <span className="text-secondary"> Katalog </span>
            </h3>
          </div>
          {download.map((down, i) => (
            <div
              className="mt-4 w-full md:w-auto bg-slate-800 transition duration-200 hover:bg-[#0f8120] rounded flex items-center py-3 px-4 ml-3"
              data-aos="fade-up"
              data-aos-duration="800"
              data-aos-delay="200"
              key={i}
            >
              <a href={down.url} className="w-full flex" target="_blank">
                <div>
                  <img src={downloadIcon} alt="" className="w-8 h-8" />
                </div>
                <div className="mt-0 poppins ml-4 flex justify-center items-center">
                  <p className="text-base text-slate-100 font-medium md:text-lg uppercase tracking-[4px]">
                    {down.name}
                  </p>
                </div>
              </a>
            </div>
          ))}
          {/* <div
            className="mt-2 md:mt-4 md:ml-3  w-full md:w-auto bg-secondary transition duration-200 hover:bg-[#0f8120] rounded flex items-center py-3 px-4"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay="1300"
          >
            <a href="" className="w-full flex">
              <div>
                <img src={downloadIcon} alt="" className="w-8 h-8" />
              </div>
              <div className="mt-0 poppins ml-4 flex justify-center items-center">
                <p className="text-base text-slate-100 font-medium md:text-lg uppercase tracking-[4px]">
                  Katalog Baju
                </p>
              </div>
            </a>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Catalog;
